import {Directive, ElementRef, HostListener, Renderer2} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {CookieService} from 'ngx-cookie-service';

@Directive({
  selector: '[appTouchEvent]'
})

export class CatchTouchEventDirective {
  public selectedLang: any;
  constructor(private el: ElementRef, private renderer: Renderer2,
              private translate: TranslateService,
               private cookieService: CookieService){

  }
  @HostListener('touchstart') getTouchEvent() {
    this.getSelectedLang(this.el.nativeElement.innerText.toLowerCase());
  }

  getSelectedLang(lang) {
    this.selectedLang = lang;
    this.changeLocalLanguage(lang);
  }

  changeLocalLanguage(lang) {
    this.translate.use(lang);
    if (this.cookieService.get('lang') !== lang) {
      window.location.reload();
    }
    this.cookieService.set('lang', lang);
  }
}



// WEBPACK FOOTER //
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/app/shared/components/header/catch-touch-event.directive.ts